import styled from 'styled-components';
import { media } from '../styledMedia';
import { spacingInRems } from '../themeUtils';

//padded div which gets 0 padding in mobile display
export default styled.div`
  && {
    padding: 0 ${spacingInRems(2)};
    ${media.xs`
      padding: 0;
  `}
  }
`;
